import { render, staticRenderFns } from "./LprImage.vue?vue&type=template&id=4a511f7e&"
import script from "./LprImage.vue?vue&type=script&lang=js&"
export * from "./LprImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports